// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Grid: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17.5">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M17.5 0h-15A2.5 2.5 0 0 0 0 2.5V15a2.5 2.5 0 0 0 2.5 2.5h15A2.5 2.5 0 0 0 20 15V2.5C20 1.12 18.879 0 17.5 0Zm.625 2.5v5.313h-7.188V1.875H17.5c.344 0 .625.28.625.625ZM2.5 1.875h6.563v5.938H1.875V2.5c0-.345.28-.625.625-.625ZM1.875 15V9.687h7.188v5.938H2.5A.626.626 0 0 1 1.875 15Zm15.625.625h-6.563V9.687h7.188V15a.627.627 0 0 1-.625.625Z"
            />
        </svg>
    );
};

export default React.memo(Grid);
